import { defineStore } from 'pinia';
import http from '../api/httpRequest.js';

export default defineStore('groupRequestStore', {
	state: () => ({
		requests: []
	}),
	actions: {
		setRequests(requests) {
			this.requests = requests;
		},
		addRequest(request) {
			const idx = this.requests.findIndex(r => r.id === request.id);
			if (idx >= 0) {
				this.requests.splice(idx, 1, request);
			} else {
				this.requests.unshift(request);
			}
		},
		removeRequest(id) {
			for (let idx in this.requests) {
				if (this.requests[idx].id == id) {
					this.requests.splice(idx, 1);
					break;
				}
			}
		},
		clear() {
			this.requests = [];
		},
		async loadRequest() {
			const requests = await http({ url: '/group/request/list', method: 'get' });
			this.setRequests(requests || []);
		}
	}
});
